export const keywords =
  'itr filing for traders, itr filing for investors, income tax filing for traders, income tax filing for investors, capital gains tax filing, tax returns for stock traders, tax filing for mutual fund investors, income tax filing on intraday trading, income tax filing on f&o trading, file itr for capital gains';

export const canonical = 'https://cleartax.in/itr-filing-for-traders';

export const description =
  'ITR Filing for Traders and Investors: File Income Tax Return for income from capital gains, equity, mutual funds, intraday, real estate, F&O and commodity trading in India.';

export const pageTitle =
  'ITR Filing for Stock Traders & Mutual Fund Investors | Capital Gains Tax Filing | ClearTax';
